import { Form } from "informed";

export default Form;
